<template>
  <div>
    <!-- 顶部 Tabs -->
    <div class="tabs-page">
      <div class="tabs-wrapper">
        <div
          v-for="tab in tabs"
          :key="tab.name"
          :class="['tab-item', { active: activeTab === tab.name }]"
          @click.stop="handleTabChange(tab.name)"
        >
          {{ tab.label }}
        </div>
      </div>
    </div>
    <div id="map" style="height: 100vh; width: 100%"></div>

    <!-- 返回按钮 -->
    <div class="map-controls">
      <button v-if="currentLevel === 'city'" @click="backToProvince">
        返回省
      </button>
      <button v-if="currentLevel === 'province'" @click="backToChina">
        返回全国
      </button>
    </div>
    <div class="status-legend">
      <div class="legend-item active">
        <img src="@/assets/imgs/icon-check.png" class="legend-icon" />
        <span>检测</span>
      </div>
      <div class="legend-item active">
        <img src="@/assets/imgs/icon-inspect.png" class="legend-icon" />
        <span>检查</span>
      </div>
      <div
        class="legend-item"
        @click="toggleGps"
        style="cursor: pointer"
        :class="{ active: showGPS }"
      >
        <img src="@/assets/imgs/car.png" class="legend-icon" />
        <span>车辆</span>
      </div>
      <div
        class="legend-item"
        @click="toggleIedevice"
        style="cursor: pointer"
        :class="{ active: showIedevice }"
      >
        <img src="@/assets/imgs/iedevice.png" class="legend-icon" />
        <span>终端</span>
      </div>
      <div
        class="legend-item"
        @click="toggleDrone"
        style="cursor: pointer"
        :class="{ active: showDrone }"
      >
        <img src="@/assets/imgs/drone.png" class="legend-icon" />
        <span>无人机</span>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'
// import 'leaflet.heat'
import axios from 'axios'
import { queryAllTask } from '@/api/screen/drone'
import { querySysData } from '@/api/detection'

import {
  getCheckInspect,
  getCheckInspectCity,
  getCheckApllyInfoByApplyId,
  getInspectApllyInfoByApplyId,
  getlatlon,
  getGpsr
} from '@/api/screen/check'

export default {
  data() {
    return {
      map: null,
      chinaLayer: null,
      geoLayer: null,
      heatLayer: null,
      cityPointLayer: null,
      currentLevel: 'province',
      selectedLabel: null,
      selectedProvince: null,
      iedeviceLayer: null,
      droneLayer: null,
      gpsrLayer: null,
      showDrone: true, // 默认显示无人机
      showGPS: true,
      showIedevice: true,
      provinceLabels: [],
      cityLabels: [],
      deviceTypeList: [],
      activeTab: 'check', // 默认检测业务
      tabs: [
        { name: 'check', label: '检测业务' },
        { name: 'inspect', label: '检查业务' }
        // { name: 'gps', label: '车辆管理' },
        // { name: 'terminal', label: '智能终端' },
        // { name: 'drone', label: '无人机巡检' }
      ],

      provinceCenters: {
        北京市: [39.9042, 116.4074],
        天津市: [39.3434, 117.3616],
        上海市: [31.2304, 121.4737],
        重庆市: [29.563, 106.5516],
        河北省: [38.0428, 114.5149],
        山西省: [37.857, 112.5492],
        辽宁省: [41.8057, 123.4315],
        吉林省: [43.8961, 125.3268],
        黑龙江省: [45.8038, 126.5349],
        江苏省: [32.0603, 118.7969],
        浙江省: [30.2741, 120.1551],
        安徽省: [31.8612, 117.2849],
        福建省: [26.0745, 119.2965],
        江西省: [28.6829, 115.8582],
        山东省: [36.6758, 117.0009],
        河南省: [34.7579, 113.6654],
        湖北省: [30.5928, 114.3055],
        湖南省: [28.1941, 112.9823],
        广东省: [23.1291, 113.2644],
        海南省: [20.0442, 110.1999],
        四川省: [30.5728, 104.0668],
        贵州省: [26.5783, 106.7135],
        云南省: [25.0453, 102.7097],
        陕西省: [34.3416, 108.9398],
        甘肃省: [36.0611, 103.8343],
        青海省: [36.6232, 101.7782],
        台湾省: [25.033, 121.5654],
        内蒙古自治区: [40.8175, 111.7656],
        广西壮族自治区: [22.815, 108.3275],
        西藏自治区: [29.652, 91.1721],
        宁夏回族自治区: [38.4872, 106.2309],
        新疆维吾尔自治区: [43.793, 87.6271],
        香港特别行政区: [22.3193, 114.1694],
        澳门特别行政区: [22.1987, 113.5439]
      }
    }
  },
  methods: {
    /** 切换 Tab */
    handleTabChange(tabName) {
      this.activeTab = tabName
      this.showGPS = true
      this.showIedevice = true
      this.showDrone = true
      // 销毁地图
      if (this.map) {
        this.map.remove() // Leaflet 提供的销毁方法
        this.map = null
        this.chinaLayer = null
        this.geoLayer = null
        // this.heatLayer = null
        this.cityPointLayer = null
        this.provinceLabels = []
        this.cityLabels = []
      }

      // 重新初始化
      // if (tabName === 'check' || tabName === 'inspect') {
      this.$nextTick(() => {
        this.initMap()
      })
      // }
    },

    initMap() {
      this.map = L.map('map', {
        center: [31.2989, 120.5853],
        minZoom: 4,
        zoomControl: false //放大缩小按钮
      })
      L.tileLayer(
        'https://t{s}.tianditu.gov.cn/vec_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&format=tiles&tileMatrix={z}&tileRow={y}&tileCol={x}&tk=e17a8af6a7274c09ceb3e3cbc45033da',
        {
          opacity: 0.3,
          subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
          attribution: '&copy; 天地图',
          maxZoom: 18
        }
      ).addTo(this.map)
      this.loadChina()
    },

    async fetchGeoJSON(adcode) {
      return fetch(
        `https://geo.datav.aliyun.com/areas_v3/bound/${adcode}_full.json`
      ).then((res) => res.json())
    },

    async loadChina() {
      const geojson = await this.fetchGeoJSON('100000')
      this.currentLevel = 'province'
      this.selectedLabel = null

      // 清空旧的省级标注
      this.provinceLabels.forEach((m) => this.map.removeLayer(m))
      this.provinceLabels = []

      // 清空旧的 gpsr 点位
      if (this.gpsrLayer) {
        this.map.removeLayer(this.gpsrLayer)
        this.gpsrLayer = null
      }
      // if (this.activeTab === 'check' || this.activeTab === 'inspect') {
      // 根据 activeTab 调接口
      let provinceData = []
      try {
        if (this.activeTab == 'check') {
          let res = await getCheckInspect()
          provinceData = Array.isArray(res.data.check) ? res.data.check : []
        } else if (this.activeTab == 'inspect') {
          let res = await getCheckInspect()
          provinceData = Array.isArray(res.data.inspect) ? res.data.inspect : []
        }
      } catch (err) {
        console.error(err)
      }

      // 绘制全国边界
      if (!this.chinaLayer) {
        this.chinaLayer = L.geoJSON(geojson, {
          style: {
            color: '#005eb8',
            weight: 2,
            dashArray: '5,6',
            fillColor: '#fff',
            fillOpacity: 0.3
          },
          onEachFeature: (feature, layer) => {
            layer.on('click', () =>
              this.loadProvinceCity(
                feature.properties.adcode,
                feature.properties.name
              )
            )
          }
        }).addTo(this.map)
      } else {
        this.chinaLayer.addTo(this.map)
        this.chinaLayer.eachLayer((layer) =>
          layer.setStyle({
            color: '#005eb8',
            weight: 2,
            fillOpacity: 0.3,
            dashArray: '5,5'
          })
        )
      }

      // ✅ 重新绘制省份 label
      this.chinaLayer.eachLayer((layer) => {
        const name = layer.feature.properties.name || '未知省'
        const center = layer.getBounds().getCenter()
        const countItem = provinceData.find((item) => item.name === name)
        const count = countItem ? countItem.count : 0
        if (count > 0) {
          const labelIcon = L.divIcon({
            className: 'district-label',
            html: `<div class="label-text" style="color:#000;font-size:14px;">${name} (${count})</div>`,
            iconSize: [100, 24],
            iconAnchor: [50, 12]
          })
          const marker = L.marker(center, {
            icon: labelIcon,
            interactive: false
          }).addTo(this.map)
          this.provinceLabels.push(marker)
        }
      })
      this.map.fitBounds(this.chinaLayer.getBounds())

      // } else if (this.activeTab === 'terminal') {
      // }

      this.markerGps()
      this.markerIemanage()
      this.markerDrone()
    },
    // ✅ GPS车辆点位打点

    async markerGps() {
      try {
        // 调用接口获取 GPS 数据
        const res = await getGpsr()
        const gpsPoints = Array.isArray(res.data) ? res.data : []

        // 自定义图标
        const gpsIcon = L.icon({
          iconUrl: require('@/assets/imgs/car.png'), // 替换成你自己的图标路径
          iconSize: [24, 24], // 图标大小
          iconAnchor: [12, 24], // 锚点在图标底部中心
          popupAnchor: [0, -24] // 弹窗相对锚点偏移
        })

        // 清除旧图层（如果存在）
        if (this.gpsrLayer) {
          this.gpsrLayer.clearLayers()
        }

        // 创建 marker 图层
        this.gpsrLayer = L.layerGroup(
          gpsPoints
            .filter((d) => d.lat && d.lng) // 过滤有效坐标
            .map((d) => {
              // 动态 popup 内容
              const popupContent = `
            <div style="min-width:180px">
              <strong>${d.carName || '暂无车牌号'}</strong><br/>
              地址：${d.addr || '暂无'}<br/>

            </div>
          `
              return L.marker([d.lat, d.lng], { icon: gpsIcon }).bindPopup(
                popupContent
              )
            })
        ).addTo(this.map)
      } catch (err) {
        console.error('加载 getGpsr 出错:', err)
      }
    },
    // ✅ 智能终端打点
    async markerIemanage() {
      try {
        const res = await axios.post(
          'https://dm.jsjxtzjc.com/prod-api/iemanage/azd/screen/map/list',
          // 'http://192.168.16.14:38080/iemanage/azd/screen/map/list',

          {}
        )
        console.log(res)
        const devicePoints = Array.isArray(res.data.data) ? res.data.data : []

        const latlngs = devicePoints
          .filter((d) => d.latitude && d.longitude)
          .map((d) => [d.latitude, d.longitude])

        // 自定义图标（终端设备图标）
        const deviceIcon = L.icon({
          iconUrl: require('@/assets/imgs/iedevice.png'), // ⚡ 替换成实际图标路径
          iconSize: [28, 28],
          iconAnchor: [14, 28]
        })

        // 清理旧图层
        if (this.iedeviceLayer) {
          this.map.removeLayer(this.iedeviceLayer)
          this.iedeviceLayer = null
        }

        this.iedeviceLayer = L.layerGroup(
          latlngs.map(
            (ll) => L.marker(ll, { icon: deviceIcon })
            // .bindPopup('智能终端')
          )
        ).addTo(this.map)
      } catch (err) {
        console.error('加载 getIedevice 出错:', err)
      }
    },
    // ✅ 无人机打点
    async markerDrone() {
      try {
        let res = await queryAllTask()
        console.log(res)
        let devicePoints = Array.isArray(res.data) ? res.data : []

        let latlngs = devicePoints
          .filter((d) => d.latitude && d.longitude)
          .map((d) => [d.latitude, d.longitude])

        // 自定义图标（终端设备图标）
        let deviceIcon = L.icon({
          iconUrl: require('@/assets/imgs/drone.png'), // ⚡ 替换成实际图标路径
          iconSize: [28, 28],
          iconAnchor: [14, 28]
        })

        // 清理旧图层
        if (this.droneLayer) {
          this.map.removeLayer(this.droneLayer)
          this.droneLayer = null
        }

        this.droneLayer = L.layerGroup(
          latlngs.map(
            (ll) => L.marker(ll, { icon: deviceIcon })
            // .bindPopup('智能终端')
          )
        ).addTo(this.map)
      } catch (err) {
        console.error('加载 getIedevice 出错:', err)
      }
    },
    toggleDrone() {
      if (!this.droneLayer) return
      this.showDrone = !this.showDrone
      if (this.showDrone) {
        this.droneLayer.addTo(this.map)
      } else {
        this.map.removeLayer(this.droneLayer)
      }
    },
    toggleGps() {
      if (!this.gpsrLayer) return
      this.showGPS = !this.showGPS
      if (this.showGPS) {
        this.gpsrLayer.addTo(this.map)
      } else {
        this.map.removeLayer(this.gpsrLayer)
      }
    },
    toggleIedevice() {
      if (!this.iedeviceLayer) return
      this.showIedevice = !this.showIedevice
      if (this.showIedevice) {
        this.iedeviceLayer.addTo(this.map)
      } else {
        this.map.removeLayer(this.iedeviceLayer)
      }
    },

    async loadProvinceCity(adcode, provinceName) {
      this.currentLevel = 'province'
      this.selectedProvince = { adcode, name: provinceName }
      this.selectedLabel = null

      this.cityLabels.forEach((m) => this.map.removeLayer(m))
      this.cityLabels = []

      if (this.chinaLayer) this.map.removeLayer(this.chinaLayer)
      if (this.geoLayer) this.map.removeLayer(this.geoLayer)
      // if (this.heatLayer) this.map.removeLayer(this.heatLayer)
      if (this.cityPointLayer) this.map.removeLayer(this.cityPointLayer)

      const cityGeo = await this.fetchGeoJSON(adcode)
      let cityData = []
      try {
        let res = await getCheckInspectCity({
          name: this.selectedProvince.name
        })
        if (this.activeTab == 'check') {
          cityData = Array.isArray(res.data.check) ? res.data.check : []
        } else if (this.activeTab == 'inspect') {
          cityData = Array.isArray(res.data.inspect) ? res.data.inspect : []
        }
      } catch (err) {
        console.error(err)
      }
      const otherCityData = ['上海市', '北京市', '天津市', '重庆市', '市辖区']
      let hasCalledGetLatLon = false

      this.geoLayer = L.geoJSON(cityGeo, {
        style: {
          color: '#1a73e8',
          weight: 2,
          dashArray: '5,5',
          fillOpacity: 0.1
        },
        onEachFeature: (feature, layer) => {
          const center = layer.getBounds().getCenter()
          const name = feature.properties.name || '未知市'
          const countItem = cityData.find((item) => item.name === name)
          const count = countItem ? countItem.count : 0
          if (count > 0) {
            // 创建 label marker，但不阻挡点击
            const labelIcon = L.divIcon({
              className: 'district-label',
              html: `<div style="color:#1a73e8;font-size:14px">${name} (${count})</div>`,
              iconSize: [100, 24],
              iconAnchor: [50, 12]
            })

            const marker = L.marker(center, {
              icon: labelIcon,
              interactive: false // ⚡ 不阻挡 GeoJSON 点击
            }).addTo(this.map)
            this.cityLabels.push(marker)

            // 点击事件绑定到 GeoJSON 面
            layer.on('click', async () => {
              // 恢复上一个选中 label 颜色
              if (this.selectedLabel?.getElement()?.querySelector('div')) {
                this.selectedLabel
                  .getElement()
                  .querySelector('div').style.color = '#1a73e8'
              }
              // 高亮当前 label
              const el = marker.getElement()?.querySelector('div')
              if (el) el.style.color = 'red'
              this.selectedLabel = marker

              // 设置当前层级
              this.currentLevel = 'city'
              if (this.cityPointLayer) this.map.removeLayer(this.cityPointLayer)

              // 异步加载城市点位
              try {
                const res = await getlatlon({
                  name: this.selectedProvince.name,
                  city: name
                })
                const pointData = Array.isArray(res.data[this.activeTab])
                  ? res.data[this.activeTab]
                  : []

                // 有效点位
                const validPoints = pointData.filter(
                  (d) => d.latitude && d.longitude
                )

                const iconSrc =
                  this.activeTab === 'check'
                    ? require('@/assets/imgs/icon-check.png')
                    : this.activeTab === 'inspect'
                    ? require('@/assets/imgs/icon-inspect.png')
                    : ''

                const labelIcon = L.icon({
                  iconUrl: iconSrc,
                  iconSize: [28, 28],
                  iconAnchor: [14, 28]
                })

                // ✅ 生成点位 + 点击后获取详情
                this.cityPointLayer = L.layerGroup(
                  validPoints.map((d) => {
                    const marker = L.marker([d.latitude, d.longitude], {
                      icon: labelIcon
                    })

                    // 默认显示基本内容（检测/检查）
                    marker.bindPopup('查询中...')

                    // ✅ 点击点位后根据 id 获取详情
                    marker.on('click', async () => {
                      try {
                        let detailRes

                        if (this.activeTab === 'check') {
                          detailRes = await getCheckApllyInfoByApplyId({
                            applyId: d.id
                          })
                        } else if (this.activeTab === 'inspect') {
                          detailRes = await getInspectApllyInfoByApplyId({
                            applyId: d.id
                          })
                        } else {
                          return
                        }

                        const detail = detailRes?.data || {}
                        // 生成设备信息 HTML（devices 为数组）
                        let deviceHtml = ''
                        if (
                          Array.isArray(detail.devices) &&
                          detail.devices.length
                        ) {
                          deviceHtml = detail.devices
                            .map(
                              (dev, i) => `
                  <div style="margin-top:4px;padding-left:8px;border-left:2px solid #1a73e8;">
                    <strong>设备 ${i + 1}</strong><br/>
                    类型：${
                      this.getOptionsType(
                        dev.deviceType,
                        this.deviceTypeList
                      ) || '未知'
                    }；
                   数量：${dev.deviceNum || '暂无'};<br/>
                  </div>
                `
                            )
                            .join('')
                        } else {
                          deviceHtml = `<div>暂无设备信息</div>`
                        }
                        const popupHtml = `
                        <div style="min-width:200px">
                         <strong>项目：${
                           detail.applyProjectname || '未知项目'
                         }</strong><br/>
                                   申请公司：${
                                     detail.applyCompany || '暂无'
                                   }<br/>
                          <div>${deviceHtml}</div>`
                        marker.getPopup().setContent(popupHtml)
                      } catch (e) {
                        console.error('加载详情失败:', e)
                        marker
                          .getPopup()
                          .setContent(
                            '<div style="color:red;">加载详情失败</div>'
                          )
                      }
                    })

                    return marker
                  })
                ).addTo(this.map)
              } catch (err) {
                console.error('获取城市点位失败：', err)
              }

              // 缩放到选中城市
              this.map.fitBounds(layer.getBounds())
            })
          } else {
            const countItems = cityData.find((item) =>
              otherCityData.some((cityName) => item.name.includes(cityName))
            )
            if (countItems && !hasCalledGetLatLon) {
              hasCalledGetLatLon = true // ⚡ 确保只执行一次
              // 创建 label marker，但不阻挡点击
              const labelIcon = L.divIcon({
                className: 'district-label',
                html: `<div style="color:#1a73e8;font-size:14px">${name} </div>`,
                iconSize: [100, 24],
                iconAnchor: [50, 12]
              })

              const marker = L.marker(center, {
                icon: labelIcon,
                interactive: false // ⚡ 不阻挡 GeoJSON 点击
              }).addTo(this.map)
              this.cityLabels.push(marker)

              this.selectedLabel = marker

              if (this.cityPointLayer) this.map.removeLayer(this.cityPointLayer)

              // 异步加载城市点位
              // try {
              getlatlon({
                name: this.selectedProvince.name,
                city: this.selectedProvince.name
              })
                .then((res) => {
                  const pointData = Array.isArray(res.data[this.activeTab])
                    ? res.data[this.activeTab]
                    : []

                  // 有效点位
                  const validPoints = pointData.filter(
                    (d) => d.latitude && d.longitude
                  )

                  const iconSrc =
                    this.activeTab === 'check'
                      ? require('@/assets/imgs/icon-check.png')
                      : this.activeTab === 'inspect'
                      ? require('@/assets/imgs/icon-inspect.png')
                      : ''

                  const labelIcon = L.icon({
                    iconUrl: iconSrc,
                    iconSize: [28, 28],
                    iconAnchor: [14, 28]
                  })

                  // ✅ 生成点位 + 点击后获取详情
                  this.cityPointLayer = L.layerGroup(
                    validPoints.map((d) => {
                      const marker = L.marker([d.latitude, d.longitude], {
                        icon: labelIcon
                      })

                      // 默认显示基本内容（检测/检查）
                      marker.bindPopup('查询中...')

                      // ✅ 点击点位后根据 id 获取详情
                      marker.on('click', async () => {
                        try {
                          let detailRes

                          if (this.activeTab === 'check') {
                            detailRes = await getCheckApllyInfoByApplyId({
                              applyId: d.id
                            })
                          } else if (this.activeTab === 'inspect') {
                            detailRes = await getInspectApllyInfoByApplyId({
                              applyId: d.id
                            })
                          } else {
                            return
                          }

                          const detail = detailRes?.data || {}
                          // 生成设备信息 HTML（devices 为数组）
                          let deviceHtml = ''
                          if (
                            Array.isArray(detail.devices) &&
                            detail.devices.length
                          ) {
                            deviceHtml = detail.devices
                              .map(
                                (dev, i) => `
                  <div style="margin-top:4px;padding-left:8px;border-left:2px solid #1a73e8;">
                    <strong>设备 ${i + 1}</strong><br/>
                    类型：${
                      this.getOptionsType(
                        dev.deviceType,
                        this.deviceTypeList
                      ) || '未知'
                    }；
                   数量：${dev.deviceNum || '暂无'};<br/>
                  </div>
                `
                              )
                              .join('')
                          } else {
                            deviceHtml = `<div>暂无设备信息</div>`
                          }
                          const popupHtml = `
                        <div style="min-width:200px">
                         <strong>项目：${
                           detail.applyProjectname || '未知项目'
                         }</strong><br/>
                                   申请公司：${
                                     detail.applyCompany || '暂无'
                                   }<br/>
                          <div>${deviceHtml}</div>`
                          marker.getPopup().setContent(popupHtml)
                        } catch (e) {
                          console.error('加载详情失败:', e)
                          marker
                            .getPopup()
                            .setContent(
                              '<div style="color:red;">加载详情失败</div>'
                            )
                        }
                      })

                      return marker
                    })
                  ).addTo(this.map)
                })
                .catch((err) => {
                  console.error('获取城市点位失败：', err)
                })
              // } catch (err) {
              //   console.error('获取城市点位失败：', err)
              // }

              // 缩放到选中城市
              this.map.fitBounds(layer.getBounds())
              // })
            }
          }
        }
      }).addTo(this.map)

      this.map.fitBounds(this.geoLayer.getBounds())
    },
    // 自定义字典展示
    getOptionsType(e, options) {
      if (options && options.length > 0) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].value == e) {
            return options[i].label
          }
        }
      }
    },
    // 获取设备类型
    querySysDataFn() {
      querySysData().then((res) => {
        this.deviceTypeList = res.data
      })
    },
    backToProvince() {
      if (!this.selectedProvince) return
      this.loadProvinceCity(
        this.selectedProvince.adcode,
        this.selectedProvince.name
      )
    },

    backToChina() {
      this.currentLevel = 'province'
      this.selectedProvince = null
      this.selectedLabel = null

      if (this.geoLayer) this.map.removeLayer(this.geoLayer)
      // if (this.cityPointLayer) this.map.removeLayer(this.cityPointLayer)
      // if (this.heatLayer) this.map.removeLayer(this.heatLayer)
      if (this.cityPointLayer) {
        this.map.removeLayer(this.cityPointLayer)
        this.cityPointLayer = null
      }

      this.cityLabels.forEach((m) => this.map.removeLayer(m))
      this.cityLabels = []

      this.loadChina()
    }
  },

  mounted() {
    this.querySysDataFn()
    this.initMap()
  }
}
</script>
<style lang="scss" scoped>
.district-label .label-text {
  font-size: 10px;
  text-align: center;
}
.map-controls {
  position: absolute;
  top: 80vh;
  left: 60vw;
  z-index: 999;
}
.map-controls button {
  margin-right: 8px;
  padding: 4px 10px;
}
/* 顶部 Tabs */
.tabs-wrapper {
  position: absolute;
  top: 1vh;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
  padding: 12px 24px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  z-index: 8;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  z-index: 9900;
}

.tab-item {
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  transition: all 0.3s ease;
}

.tab-item:hover {
  background: #f0f4ff;
  color: #1a73e8;
}

.tab-item.active {
  background: rgba(85, 144, 217, 1);
  color: #fff;
  font-weight: 600;
  box-shadow: 0 3px 6px rgba(26, 115, 232, 0.3);
}
.status-legend {
  position: absolute;
  bottom: 10vh;
  right: 25vw;
  z-index: 999;
  background: rgba(255, 255, 255, 0.8); /* 半透明背景 */
  padding: 10px 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 14px;
}

.legend-item {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  cursor: pointer;
  opacity: 0.4;
  transition: 0.2s;
}

.legend-item.active {
  opacity: 1;
  transform: scale(1.05);
}

.legend-item:hover {
  opacity: 0.7;
}

.legend-item:last-child {
  margin-bottom: 0;
}

.legend-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
</style>
